import { render, staticRenderFns } from "./EditBooking.vue?vue&type=template&id=351fde0f&scoped=true"
import script from "./EditBooking.vue?vue&type=script&lang=js"
export * from "./EditBooking.vue?vue&type=script&lang=js"
import style0 from "./EditBooking.vue?vue&type=style&index=0&id=351fde0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351fde0f",
  null
  
)

export default component.exports